/*
  ============================================================
  REVIVE HAIR ARTISTS - Product Page Enhancements
  File: assets/revive-product.js
  Link from: sections/main-product.liquid
  <script src="{{ 'revive-product.js' | asset_url }}" defer></script>
  ============================================================
*/

(function() {
  'use strict';

  function init() {

    // ── 1. Insert salon badge above the price ──
    var price = document.querySelector('.price, .product__price');
    if (price && !document.querySelector('.rha-salon-badge')) {
      var badge = document.createElement('div');
      badge.className = 'rha-salon-badge';
      badge.innerHTML = '<span class="rha-salon-badge__dot"></span>'
        + '<span class="rha-salon-badge__text">Used in our Codsall salon</span>';
      price.parentNode.insertBefore(badge, price);
    }

    // ── 2. Insert trust strip below the buy buttons ──
    var buyButtons = document.querySelector('.product-form__buttons, .shopify-payment-button');
    if (buyButtons && !document.querySelector('.rha-trust-strip')) {
      var strip = document.createElement('div');
      strip.className = 'rha-trust-strip';
      strip.innerHTML = ''
        + '<div class="rha-trust-item">'
        +   '<svg class="rha-trust-item__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">'
        +     '<path d="M5 12h14M12 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/>'
        +   '</svg>'
        +   '<div>'
        +     '<div class="rha-trust-item__text">Free UK Delivery</div>'
        +     '<span class="rha-trust-item__sub">On all orders</span>'
        +   '</div>'
        + '</div>'
        + '<div class="rha-trust-item">'
        +   '<svg class="rha-trust-item__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">'
        +     '<path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" stroke-linecap="round" stroke-linejoin="round"/>'
        +   '</svg>'
        +   '<div>'
        +     '<div class="rha-trust-item__text">Easy Returns</div>'
        +     '<span class="rha-trust-item__sub">Hassle-free policy</span>'
        +   '</div>'
        + '</div>'
        + '<div class="rha-trust-item">'
        +   '<svg class="rha-trust-item__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">'
        +     '<path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" stroke-linecap="round" stroke-linejoin="round"/>'
        +   '</svg>'
        +   '<div>'
        +     '<div class="rha-trust-item__text">Salon Approved</div>'
        +     '<span class="rha-trust-item__sub">Professional quality</span>'
        +   '</div>'
        + '</div>';

      // Insert after buy buttons' parent container
      var container = buyButtons.closest('.product-form') || buyButtons.parentElement;
      container.insertAdjacentElement('afterend', strip);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());